import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { recordFirstTouch } from '../../services/acquisitionService';
import { COMPANY } from '../content/company';
import { HOME_INTRO, HOME_META, HOME_SECTIONS, HOW_IT_WORKS_STEPS, PILLARS_LABEL, WHY_MELIO_STRIP } from '../content/home';
import { PILLARS } from '../content/pillars';
import HealthCheckBand from '../sections/HealthCheckBand';
import Hero from '../sections/Hero';
import HowItWorks from '../sections/HowItWorks';
import ImageStrip from '../sections/ImageStrip';
import IntroStatement from '../sections/IntroStatement';
import NumberedSection from '../sections/NumberedSection';
import PillarList from '../sections/PillarList';

/**
 * The home page as the brand guidelines draw it (pp.52–55): a photograph
 * with the nav over it and nothing else, the statement, "WHY MELIO?" as a
 * four-up strip, the eight pillars, how it works, and the Health Check.
 * Records first touch, as the previous home page did — for most visitors
 * this is the only page, so attribution not captured here is not captured.
 */
export default function MarketingHomePage() {
  useEffect(() => {
    try {
      recordFirstTouch();
    } catch (err) {
      console.warn('recordFirstTouch failed', err);
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>{HOME_META.title}</title>
        <meta name="description" content={HOME_META.description} />
        <link rel="canonical" href={`${COMPANY.siteUrl}/`} />
      </Helmet>

      <Hero image="hero-frost-fields" video="hero-frost-fields" />
      <IntroStatement statement={HOME_INTRO.statement} link={HOME_INTRO.link} />

      <NumberedSection id="why-melio" numeral={HOME_SECTIONS.why.numeral} title={HOME_SECTIONS.why.title}>
        <ImageStrip items={WHY_MELIO_STRIP} label="Why Melio" />
      </NumberedSection>

      <section className="mk-section" aria-label={PILLARS_LABEL}>
        <div className="mk-container">
          <PillarList pillars={PILLARS} label={PILLARS_LABEL} />
        </div>
      </section>

      <NumberedSection id="how-it-works" numeral={HOME_SECTIONS.how.numeral} title={HOME_SECTIONS.how.title}>
        <HowItWorks steps={HOW_IT_WORKS_STEPS} />
      </NumberedSection>

      <HealthCheckBand />
    </>
  );
}
